module.exports = __webpack_public_path__ + "static/media/covid_qr_p2_2.6bf9d52f.png";